export default class SnpError extends Error {
    constructor(status, message) {
      super(message); // Call the parent constructor with the message
      this.status = status; // Add a custom status property
    }
  }
  